/** @format */

export const FilterReducerFieldName = {
    HEADER_FILTER_MANAGE: 'headerFilterManage',
    HEADER_FILTER_ELEMENT_HAS_VALUE: 'headerFilterElementHasValue',
    HEADER_FILTER_ELEMENT_NAME: 'headerFilterElementName',
    HEADER_FILTER_MANAGE_ELEMENT: 'headerFilterManageElement',
};

export type FilterReducers = {
    type: string;
    headerFilterElementName?: string;
    headerFilterElementHasValue?: boolean;
    clearAll?: boolean;
    filterItemManage: {shouldRemove?: boolean;key: string; value: string;}
};

export function filterReducer(state: any, action: FilterReducers): object {
    switch (action.type) {
        case FilterReducerFieldName.HEADER_FILTER_MANAGE:
            return action;
        case FilterReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT:
            return action;
        default:
            return {
                ...state,
            };
    }
}
